import jsPDF from 'jspdf';
import { printPdfInHiddenIframe } from './printFrame';
import { ESC } from './printUtility';

export const customerName = client => client.entreprise || [client.nom, client.prenom].filter(Boolean).join(' ') || client.code || 'Client';
export const customerBalance = client => Math.round((Number(client.totalDebit || 0) - Number(client.totalCredit || 0)) * 100) / 100;
export const customerBalanceLabel = balance => balance > 0 ? 'Reste à payer' : balance < 0 ? 'En faveur du client' : 'Tout est payé';

export const situationTicketLines = (client, businessName, date = new Date()) => {
  const balance = customerBalance(client);
  return [
    businessName || 'MATJARPOS',
    'SITUATION CLIENT',
    date.toLocaleString('fr-MA'),
    customerName(client),
    client.code ? `Client : ${client.code}` : '',
    client.telephone1 ? `Tél : ${client.telephone1}` : '',
    '--------------------------------',
    `Achats et débits : ${Number(client.totalDebit || 0).toFixed(2)} DH`,
    `Paiements et crédits : ${Number(client.totalCredit || 0).toFixed(2)} DH`,
    '--------------------------------',
    customerBalanceLabel(balance),
    `${Math.abs(balance).toFixed(2)} DH`,
    balance > 0 ? 'Ce montant reste à payer.' : balance < 0 ? 'Ce montant est en votre faveur.' : 'Vous ne devez plus rien.',
    'Résumé du compte à cette date.',
    'Merci de votre confiance.',
  ].filter(Boolean);
};

export const buildSituationEscPos = (client, businessName, width = 80, date) => {
  const columns = width === 58 ? 32 : 48;
  const lines = situationTicketLines(client, businessName, date).flatMap(line => {
    const plain = line.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/’/g, "'");
    return plain.match(new RegExp(`.{1,${columns}}`, 'g')) || [''];
  });
  return ESC.INIT + ESC.CODEPAGE_CP850 + ESC.LEFT + lines.join('\n') + '\n\n\n' + ESC.CUT;
};

export const buildSituationPdf = (client, businessName, width = 80, date) => {
  const doc = new jsPDF({ unit: 'mm', format: [width, 220], orientation: 'portrait' });
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  const lines = situationTicketLines(client, businessName, date).flatMap(line => doc.splitTextToSize(line, width - 8));
  const height = Math.max(100, lines.length * 5 + 12);
  doc.internal.pageSize.setHeight(height);
  lines.forEach((line, index) => doc.text(line, 4, 7 + index * 5));
  return doc;
};

export const printCustomerSituation = (client, businessName, width = 80) => {
  if (/Android/i.test(navigator.userAgent)) {
    window.location.href = `rawbt://print?text=${encodeURIComponent(buildSituationEscPos(client, businessName, width))}`;
  } else {
    printPdfInHiddenIframe(buildSituationPdf(client, businessName, width).output('bloburl'));
  }
};
